import { LeftBar } from "../../components";
import Main from "./component.main";
import store from "./script.store";
const Medias = { LeftBar, Main, store };
export default Medias;
